import type LazySizes from 'lazysizes'

import { processThumbSrc, processThumbSrcset } from './pg-thumbs-helpers'

declare global {
    interface Window {
        lazySizes: typeof LazySizes
        lazySizesConfig?: LazySizes.LazySizesConfigPartial
    }
}

const init = () => {
    if (typeof window === 'undefined') {
        return
    }

    // lazysizes config
    // see https://github.com/aFarkas/lazysizes?tab=readme-ov-file#js-api for details
    window.lazySizesConfig = window.lazySizesConfig || {}
    window.lazySizesConfig.expFactor = 3 // increase auto-expansion boost when browser is idle (default ~1.5)
    window.lazySizesConfig.expand = 1000 // preload images earlier by enlarging the virtual viewport

    window.document.addEventListener('lazybeforeunveil', (e: Event) => {
        const target = e.target as HTMLElement & { _lazysizesWidth: number }

        // top playgama svg cards
        if (target.dataset['pgTop']) {
            for (const image of target.querySelectorAll('image')) {
                image.setAttribute('href', image.dataset.href || '')
            }
            e.preventDefault()
            return
        }

        const width = target._lazysizesWidth
        if (!width) {
            return
        }
        const { src } = target.dataset
        if (!src) {
            return
        }

        target.dataset.src = processThumbSrc(src, width)
        target.dataset.srcset = processThumbSrcset(src, width)
    })
}

init()
